<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="teacherAssignForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Examiner Availability
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Examiner Availability Request
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Request Type</mat-label>
                            <mat-select formControlName="ReqType" #select3904 placeholder="Request Type"
                                class="colorblack">
                                <mat-select-filter *ngIf="select3904.focused" [placeholder]="'Request Type'"
                                    [displayMember]="'CdCode'" [array]="requestTypeList"
                                    (filteredReturn)="filteredrequestTypeList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredrequestTypeList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['ReqType'].touched && teacherAssignForm.controls['ReqType'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Session</mat-label>
                            <mat-select #select232 placeholder="Session" class="colorblack" formControlName="SessionId"
                                required>
                                <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                    [displayMember]="'SnName'" [array]="sessionList"
                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                    {{item.SnName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['SessionId'].touched && teacherAssignForm.controls['SessionId'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Course</mat-label>
                            <mat-select #select122 placeholder="Course" formControlName="CoCode" required>
                                <mat-select-filter *ngIf="select122.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredListCourse =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode"
                                    (click)="getsubjects(item.CoCode)">
                                    {{item.CoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['CoCode'].touched && teacherAssignForm.controls['CoCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Subject</mat-label>
                            <mat-select required #select123 placeholder="" class="colorblack" formControlName="SubCode" required>
                                <mat-select-filter *ngIf="select123.focused" [placeholder]="'Filter'"
                                    [displayMember]="'EsName'" [array]="subjectList"
                                    (filteredReturn)="filteredsubjectList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredsubjectList" [value]="item.EsId"
                                    (click)="getCount(item)">
                                    {{item.EsName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['SubCode'].touched && teacherAssignForm.controls['SubCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="showFieldsForAdd" class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Availability From Date</mat-label>
                            <input  required class="color" matInput [matDatepicker]="picker" placeholder=""
                                formControlName="FromDate">
                            <mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['FromDate'].touched && teacherAssignForm.controls['FromDate'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="showFieldsForAdd" class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Availability To Date</mat-label>
                            <input  required class="color" matInput [matDatepicker]="picker1" placeholder=""
                                formControlName="ToDate">
                            <mat-datepicker-toggle  matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['ToDate'].touched && teacherAssignForm.controls['ToDate'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="showFieldsForAdd" class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Reply Before</mat-label>
                            <input required class="color" matInput [matDatepicker]="ReplyBefore" placeholder=""
                                formControlName="ReplyBefore">
                            <mat-datepicker-toggle matSuffix [for]="ReplyBefore"></mat-datepicker-toggle>
                            <mat-datepicker #ReplyBefore></mat-datepicker>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['ReplyBefore'].touched && teacherAssignForm.controls['ReplyBefore'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div style="color: red;" *ngIf="msgShow && !showFieldsForAdd" class="col-sm-12 row">
                        {{AvailabilityMesg}}
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                             <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                            <button *ngIf="showProviReport" id="Reciprocal" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1 mr-2" (click)="GenerateReciprocalProviList()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Reciprocal Provisional List
                                </span>
                            </button>
                            <button *ngIf="showProviReport" id="Generate" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="GenerateProviList()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Generate Provisional List
                                </span>
                            </button>
                            <button *ngIf="showFieldsForAdd" id="Save" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="save()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Send Request
                                </span>
                            </button>
                           
                        </div>
                    </div>

                    <hr class="mt-1">
                    <div *ngIf="InterTeach" class="mb-2">
                        <label>
                            <input [disabled]="showProviReport"  [checked]="selectAllChecked" type="checkbox" (change)="toggleSelectAll($event)">
                            Select All(Total:{{ teachersList?.length || 0 }})
                        </label>
                    </div>
                    <div class="table-responsive table-container">
                        <table *ngIf="InterTeach" appShortTable id="datatable"
                            class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th class="f600 text-center" width="5%"> Action </th>
                                    <th class="f600 text-left" width="5%"> Examiner Name </th>
                                    <th class="f600 text-left" width="20%"> Designation </th>
                                    <th class="f600 text-left" width="20%"> Home College </th>
                                    <th class="f600 text-left" width="90%"> College District </th>
                                    <th class="f600 text-left" width="20%"> Is HOD </th>
                                    <th *ngIf="showProviReport" class="f600 text-left" width="20%"> Availability </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="allTeachersArray">
                                <tr *ngFor="let subject of getControlsAllTachers(); let i = index " [formGroupName]="i">
                                    <td class="text-center">
                                        <mat-checkbox
                                            [disabled]="showProviReport"
                                            [checked]="subject.get('teachercheckbox').value"
                                            (change)="selectSingleTeacher(i, $event.checked)">
                                        </mat-checkbox>
                                    </td>
                                    <td class="text-left">{{ subject.get('TeacherName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Designation').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('CollegeName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('DsName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('HOD').value === true ||
                                        subject.get('HOD').value === 'true' ? 'Yes' : 'No' }}
                                    </td>
                                    <td *ngIf="showProviReport" class="text-left">
                                        {{ subject.get('Availability').value == 1 ? 'Available' : 
                                         subject.get('Availability').value == 0 ? 'Not Available' : 'No Response' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>